<template lang="html">
 <transition name="move">
  <div class="myaddresseditlist" v-show="showFlag" ref="mymessage">
    <div class="myaddresseditlist-content"> 
      <!-- <pre>默认地址 {{state.defaultaddress}}</pre> -->
        <div class="rating-wrapper">
            <ul>
              <!-- 点击传递index -->
            <li class="rating-item" v-for="(item,index) in myaddresseditlist" @click="selectFood(index,item,$event)">
                <div class="content">
                  <!-- 收货人 -->
                  <h1 class="name">{{ $t('name') }}:{{item.CustomerName}}  </h1> 
                  <div class="star-wrapper">
                      <span class="delivery" >{{item.Street}} , {{item.City}}</span>
                  </div>
                  <div class="star-wrapper">
                      <span class="delivery" >{{item.Province}} , {{item.Zip}}</span>
                  </div>
                  <div class="time">
                  <!-- 电话 -->
                  {{ $t('phone') }} : {{item.LinkmanPhone}}
                     </div>
                  <div class="defaultaddress">
                    <input class="checkbtn" type="radio" :value='index' v-model="state.defaultaddress" > 
                  </div>
                </div>
            </li>
              <li class="rating-item" @click="addAddress($event)">
                <div class="content">
                  <div class="add-address">
                    <i class="icon-add_circle" style="color: #00b43c;"></i>
                  </div>
                </div>
              </li>
            </ul>
          </div> 
     </div> 
  <myaddressedit ref="myaddressedit"></myaddressedit>
  </div>
  </transition>
</template>

<script>
import myaddressedit from 'components/myaddress/myaddressedit.vue'
import eventbus from '../../common/js/eventbus.js'
import {Encrypt} from 'common/js/secret.js'
import BScroll from 'better-scroll'

export default {
  props: {
  },
  data() {
    return {
      myaddresseditlist: [],
      myaddresseditobj: {},
      showFlag: false,
      state: this.$store.state
    }
  },
  methods: {
    show() {
      // 加入状态过滤,show的时候才刷新数据,如果是created就读取api,那就不是刷新了,而是进入我的信息页面就立刻读取.费流量
      this.showFlag = true
      if (this.state.myinfo !== null && this.state.myinfo.openId !== 'undefined' && this.state.myinfo.openId !== '') {
        this.$http.get(this.api.getUser + '?openId=' + encodeURIComponent(Encrypt(this.state.myinfo.openId || '')) + '&hash=' + encodeURIComponent(this.state.myinfo.hash || '') + '&SellerID=' + (this.state.myinfo.SellerID || 1) + this.state.ibnumber)
        .then((res) => {
          this.state.myinfo = res.data.data[0]
          this.state.uuid = this.state.myinfo.openId
          this.myaddresseditlist = res.data.data[0].addres
          if (this.$store.state.dev) console.log('我的地址列表刷新资料', this.state.myinfo)
          this.$nextTick(() => {
            this.scroll = new BScroll(this.$refs.mymessage, {
              click: true
            })
          })
        })
        .catch(err => {
          console.log(`登录失败${err}`)
        })
      }
      eventbus.$emit('returnfun', this.hide)
    },
    hide() {
      this.showFlag = false
    },
    refresh() {
    },
    isshow() {
      return this.showFlag
    },
    prev() {
      this.$router.go(-1)
    },
    selectFood(index, data, e) {
      if (!event._constructed) {
        return
      }
      // this.myaddresseditobj = data
      // 改为点击传递index
      // <li class="rating-item" v-for="(item,index) in myaddresseditlist" @click="selectFood(index,item,$event)">
      // 地址详情页面拿index读取公共变量数组干活
      this.$refs.myaddressedit.show(index)
    },
    addAddress(e) {
      console.log('触发点击了')

      // if (!event._constructed) {
      //   console.log('退出了')
      //   return
      // }

      if (this.$store.state.dev) console.log('添加')
      // 传递-1意思是新添加的地址行

      this.$refs.myaddressedit.show(-1)
      console.log('成功了')
    },
    saveinfo() {
      // console.log('我的地址 saveinfo - state', this.state)
      // this.$store.dispatch('saveinfo', this.state)
    }
  },
  mounted() {
    eventbus.$on('refresh_myaddresseditlist', item => {
      this.myaddresseditlist = item.addres
    })
  },
  beforeDestroy () {
    eventbus.$off('refresh_myaddresseditlist')
  },
  computed: {
    // 监听语言改变,由于不能直接监听对象,所以要用computed实现
    defaultaddress() {
      return this.state.defaultaddress
    }
  },
  watch: {
    // 监听语言改变,由于不能直接监听对象,所以要用computed实现
    defaultaddress(val) {
      console.log(val)
      // this.$store.dispatch('savedefaultaddress', val)
      this.$store.dispatch('saveinfo', this.state)
    }
  },
  filters: {

  },
  components: {
    myaddressedit
  }
}
</script>

<style lang="scss">
@import '../../common/sass/mixin.scss';

.myaddresseditlist {
  position: absolute;
  left: 0;
  top: 0px;
  bottom: 46px;
  width: 100%;
  background: #fff;
    overflow: hidden;
    z-index:10;
  &.move-enter-active, &.move-leave-active { // 动画过程
    transition: all .5s;
    transform: translate3d(0,0,0);
  }
  &.move-enter, &.move-leave-to { // 动画初始态
    transform: translate3d(100%,0,0);
  }

  // .myaddresseditlist-content{
  //     // overflow-y: auto;
  //     // overflow-x: hidden;
  //     // -webkit-overflow-scrolling: touch;
  //     // position: absolute;
  //     left: 0;
  //     top: 0px;
  //     bottom: 0px;
  //     width: 100%;
    .rating-wrapper {
      padding: 0 18px;
      .rating-item {
        display: flex;
        padding: 18px 0;
        @include border-1px(rgba(7,17,27,0.1));
        .avatar {
          flex: 0 0 28px;
          width: 28px;
          height: 28px;
          margin-right: 12px;
          border-radius: 50%;
          overflow: hidden;
          img {
            width: 100%;
          }
        }
        .content {
          position: relative;
          flex: 1;
          .name {
            margin-bottom: 4px;
            line-height: 12px;
            font-size: 10px;
            color: rgb(7,17,27);
          }
          .star-wrapper {
            margin-bottom: 6px;
            font-size: 0;
            .star {
              display: inline-block;
              vertical-align: top;
              margin-right: 6px;
            }
            .delivery {
              display: inline-block;
              vertical-align: top;
              line-height: 12px;
              font-size: 10px;
              color: rgb(147,153,159);
            }
          }
          .text {
            margin-bottom: 8px;
            line-height: 18px;
            font-size: 12px;
            color: rgb(7,17,27);
          }
          .time {
            position: absolute;
            top: 0;
            right: 0;
            line-height: 12px;
            font-size: 10px;
            color: rgb(147,153,159);
          }
          .checkbtn {
            height: 16px;
            width: 16px;
            color: rgb(0, 180, 60);
          }
          .defaultaddress{
            position: absolute;
            top: 32px; 
            right:2px;
            line-height: 30px; 
            color: rgb(147,153,159);
          }
          .add-address {
            // width: 32px;
            // height: 32px;
            // line-height: 12px;
            // font-size: 10px;
            // clear: both;
            width: 32px;
            height: 32px;
            font-size: 32px;
            line-height: 32px;
            clear: both;
            right: 9px;
            margin: auto;
          }
        }
      }
    }
  // }
}


</style>



// WEBPACK FOOTER //
// myaddress.vue?61de06e8